function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseEarly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 20.58,
    cy: 20.43,
    r: 5.57,
    style: {
      fill: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.58,
    cy: 20.43,
    r: 4.26,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "20.9 20.09 20.9 17.48 19.59 17.48 19.59 21.41 20.9 21.41 23.53 21.41 23.53 20.09 20.9 20.09",
    style: {
      fill: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7,20.47A5.53,5.53,0,0,1,14.93,17,8.46,8.46,0,0,1,13.46,6a9.82,9.82,0,0,0,2.21,19.39,6.91,6.91,0,0,0,.91,0A5.56,5.56,0,0,1,13.7,20.47Z",
    style: {
      fill: "#eac282"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseEarly);
export default __webpack_public_path__ + "static/media/close-early.6443b57b.svg";
export { ForwardRef as ReactComponent };